export var getPlayerCss = function getPlayerCss(isResponsive, width, height) {
  return width && height && isResponsive ? {
    paddingTop: "".concat(100 / (width / height), "%")
  } : {};
};